// ink-component
import React, { ReactNode } from 'react';

import getGlobalProps from '../../../helpers/constants/global-props';
import { RowWrapper } from '../styles';

export interface RowProps {
  /** Any number of Columns */
  children: ReactNode;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
}

const globalProps = getGlobalProps({});

/**
 * @purpose Group any number of columns of any size
 * @group Grid
 */
export function Row({ children, ...otherProps }: RowProps) {
  return (
    <RowWrapper data-testid={otherProps['data-testid']} {...globalProps}>
      {children}
    </RowWrapper>
  );
}

Row.defaultProps = {
  children: undefined,
  'data-testid': undefined,
};

Row.displayName = 'Row';

export default Row;
